import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";
import Tab from "@mui/material/Tab";
import React from "react";
import ComfirmOrder from "./Tabs/ComfirmOrder";
import _ from "lodash";
import DeliveredOrder from "./Tabs/DeliveredOrder";
import ProductionOrder from "./Tabs/ProductionOrder";
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useSelector } from "react-redux";
import { Typography } from "@mui/material";

export default function Status({
  orderByStatusData,
  selectedDate,
  handleStatus,
}) {
  const isMediumScreen = useMediaQuery('(min-width: 960px)');
  const [value, setValue] = React.useState("1");
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const role = useSelector((state) => state.currentUser.role);
  //console.log(orderByStatusData);
  const deliveredOrders = orderByStatusData?.delivered;
  const productionOrders = (orderByStatusData?.order || []).concat(
    (orderByStatusData?.production || []).filter((row) => row.status === "production")
  );
  //console.log(productionOrders)
  const ConfirmOrders = orderByStatusData?.production.filter(
    (row) => row.status === "dispatched"
  );

  
  return (
    <div>
      <Stack alignItems="center">
          <Grid item xs={12} md={6}>
            <TabContext value={value} >
              <Box
                sx={{
                  borderBottom: 1,
                  borderColor: "divider",
                  display: "flex",
                  justifyContent: "center",
                }}
              >

                <TabList
                  onChange={handleChange}
                  aria-label="lab API tabs example"
                  sx={{
                    minWidth: isMediumScreen ? 600 : 300,
                    padding: "0rem",
                    flexDirection: "column", // Stack tabs vertically on mobile
                    alignItems: "center", // Center align tabs horizontally and vertically
                  }}
                >
    <Tab
      label={
          productionOrders && productionOrders.length > 0
          ? `Production(${productionOrders.length})`
          : "Production"
      }
      value="1"
      sx={{
        width: "34%", 
        textAlign: "center", 
        fontSize: { xs: "11px", md: "inherit" }, 
        fontWeight:{xs:'bold',},
        color: role === "cs" && productionOrders && productionOrders.length  > 0 ? "green" : "inherit" 
      }}
    />
    <Tab
      label={
          ConfirmOrders && ConfirmOrders.length > 0
          ? `Dispatched(${ConfirmOrders.length})`
          : "Dispatched"
      }
      value="2"
      sx={{
        width: "33%", 
        textAlign: "center", 
        fontSize: { xs: "11px", md: "inherit" },
        fontWeight:{xs:'bold'} ,
        color: role === "cs" && ConfirmOrders && ConfirmOrders.length > 0 ? "green" : "inherit"
      }}
    />
    <Tab
      label={
        deliveredOrders && deliveredOrders.length > 0
          ? `Delivered(${deliveredOrders.length})`
          : "Delivered"
      }
      value="3"
      sx={{
        width: "33%", 
        textAlign: "center", 
        fontSize: { xs: "11px", md: "inherit" }, 
        fontWeight:{xs:'bold'},
        color: role === "cs" && deliveredOrders && deliveredOrders.length > 0 ? "green" : "inherit"
      }}
    />
                </TabList>
                </Box>
  
              <TabPanel value="1">
                <ProductionOrder
                  orderProduction={productionOrders}
                  selectedDate={selectedDate}
                  handleStatus={handleStatus}
                />
              </TabPanel>
  
              <TabPanel value="2">
                <ComfirmOrder
                  orderProduction={ConfirmOrders}
                  selectedDate={selectedDate}
                  handleStatus={handleStatus}
                />
              </TabPanel>
  
              <TabPanel value="3">
                <DeliveredOrder
                  deliveredOrder={orderByStatusData?.delivered}
                  selectedDate={selectedDate}
                />
              </TabPanel>
          </TabContext>
          </Grid>
      </Stack>
    </div>
  );
  
  
}
